var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, } from "react";
import { FontIcon } from "./FontIcon";
var DEFAULT_ICONS = {
    back: _jsx(FontIcon, { children: "keyboard_arrow_left" }, void 0),
    checkbox: _jsx(FontIcon, { children: "check_box" }, void 0),
    download: _jsx(FontIcon, { children: "file_upload" }, void 0),
    dropdown: _jsx(FontIcon, { children: "arrow_drop_down" }, void 0),
    error: _jsx(FontIcon, { children: "error_outline" }, void 0),
    expander: _jsx(FontIcon, { children: "keyboard_arrow_down" }, void 0),
    forward: _jsx(FontIcon, { children: "keyboard_arrow_right" }, void 0),
    menu: _jsx(FontIcon, { children: "menu" }, void 0),
    notification: _jsx(FontIcon, { children: "notifications" }, void 0),
    password: _jsx(FontIcon, { children: "remove_red_eye" }, void 0),
    radio: _jsx(FontIcon, { children: "radio_button_checked" }, void 0),
    selected: _jsx(FontIcon, { children: "check" }, void 0),
    sort: _jsx(FontIcon, { children: "arrow_upward" }, void 0),
};
var context = createContext(DEFAULT_ICONS);
var Provider = context.Provider;
/**
 * Gets one of the configured icons from the `IconProvider`. This is probably
 * just for use within `react-md`, but might be helpful outside if you want to
 * reuse the existing icon configuration for other custom components.
 *
 * If te second argument is provided and it is not `undefined`, that value will
 * be used instead of the inherited icon type.
 *
 * @param name - The name of the icon you want to use.
 * @param override - An optional override to use instead of the inherited icon.
 * @returns The overridden icon value or the inherited icon.
 */
export function useIcon(name, override) {
    var icons = useContext(context);
    if (typeof override !== "undefined") {
        return override;
    }
    return icons[name];
}
/**
 * The `IconProvider` component is used to override all the default icons within
 * `react-md` with a newly defined set of icons. This is super nice since you
 * won't need to create new component wrappers for all the components within
 * `react-md` if you want to switch to SVG icons instead of the default font
 * icons.
 */
export function IconProvider(_a) {
    var children = _a.children, _b = _a.back, back = _b === void 0 ? DEFAULT_ICONS.back : _b, _c = _a.checkbox, checkbox = _c === void 0 ? DEFAULT_ICONS.checkbox : _c, _d = _a.download, download = _d === void 0 ? DEFAULT_ICONS.download : _d, _e = _a.dropdown, dropdown = _e === void 0 ? DEFAULT_ICONS.dropdown : _e, _f = _a.expander, expander = _f === void 0 ? DEFAULT_ICONS.expander : _f, _g = _a.error, error = _g === void 0 ? DEFAULT_ICONS.error : _g, _h = _a.forward, forward = _h === void 0 ? DEFAULT_ICONS.forward : _h, _j = _a.menu, menu = _j === void 0 ? DEFAULT_ICONS.menu : _j, _k = _a.notification, notification = _k === void 0 ? DEFAULT_ICONS.notification : _k, _l = _a.password, password = _l === void 0 ? DEFAULT_ICONS.password : _l, _m = _a.radio, radio = _m === void 0 ? DEFAULT_ICONS.radio : _m, _o = _a.selected, selected = _o === void 0 ? DEFAULT_ICONS.selected : _o, _p = _a.sort, sort = _p === void 0 ? DEFAULT_ICONS.sort : _p;
    var value = useMemo(function () { return ({
        back: back,
        checkbox: checkbox,
        download: download,
        dropdown: dropdown,
        error: error,
        expander: expander,
        forward: forward,
        menu: menu,
        notification: notification,
        password: password,
        radio: radio,
        selected: selected,
        sort: sort,
    }); }, [
        back,
        checkbox,
        download,
        dropdown,
        error,
        expander,
        forward,
        menu,
        notification,
        password,
        radio,
        selected,
        sort,
    ]);
    return _jsx(Provider, __assign({ value: value }, { children: children }), void 0);
}
//# sourceMappingURL=IconProvider.js.map